export const CREATE_WITH_AGENT_COPY = {
  menu: "Create with an Agent",
  title: "New task with an agent",
  titleRefine: "Refine this task",
  endSession: "End session",
  endSessionAsk: "End this session?",
  endSessionBody: "The machine will stop. Tasks you already created stay in the backlog.",
  endSessionConfirm: "End session",
  keepSession: "Keep session",
  send: "Send",
  you: "You",
  youSurvey: "Answer",
  surveyAnswerSkipped: "Skipped",
  request: "Request",
  sendAnswer: "Send answer",
  sendAnswers: "Send answers",
  skipSurvey: "Skip",
  recommendedOption: "Recommended",
  previousQuestion: "Previous",
  nextQuestion: "Next",
  otherAnswer: "Or write your own answer",
  surveySkipped: "Skipped the survey.",
  composerPlaceholder: "Tell the agent what you want to do",
  composerPlaceholderRefine: "Tell the agent what you want to change",
  viewingOlder: "You are viewing older messages.",
  jumpToLatest: "Jump to latest",
  machineStarting: "The machine is starting",
  logStarting: "Starting the planning session.",
  machineRunning: "Machine is running",
  machineWaiting: "Waiting for you",
  machineStopped: "The machine stopped",
  machineFailedBody: "The run failed. End this session and start again.",
  emptyHeadline: "Waiting for your first task.",
  emptyBody: "The agent will draft a task here.",
  draftLabel: "Draft task",
  sessionList: "This session",
  create: "Create",
  update: "Update",
  skip: "Skip",
  refine: "Refine",
  refineTooltip: "Ask an agent to update this task.",
  refineFurther: "Refine further",
  openTask: "Open task",
  planUpdated: "Plan updated",
  plan: "Plan",
  showPlan: "Show plan",
  hidePlan: "Hide plan",
  greeting: "The repository is ready. What do you want to do?",
  afterCreate: "The task is created. Tell me if you want to do something else.",
  afterSkip: "Skipped that draft. Tell me if you want to do something else.",
  failedStart: "Failed to start the session.",
  failedSend: "Failed to send the message.",
  failedSurvey: "Failed to send the answers.",
  failedDraft: "Failed to save the draft.",
  failedCreate: "Failed to create the task.",
  failedUpdate: "Failed to update the task.",
  failedSkip: "Failed to skip the draft.",
  failedReload: "Failed to reload the agent.",
  usingModel: (label: string) => `Using ${label}`,
  selectModel: "Select a model",
  noModels: "No models are available.",
} as const;

export function planningRefineNote(key: string, title: string) {
  return `Refine ${key}: ${title}.`;
}

export function isPlanningRefineNote(text: string) {
  const match = /^Refine (\S+): .+\.$/.exec(text.trim());
  return Boolean(match?.[1] && /-\d+$/.test(match[1]));
}
